import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import Banner from "../components/Banner";
import BookingCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/BookingCard";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import Config from "../Config";

const cdnUrl = Config.getCdnUrl();
const bgImage = cdnUrl + "/assets/img/blog_banner.jpg";
const ultimateBackendImg = cdnUrl + "/assets/img/introducing-olympus-grid.webp";
const goldbergMachineImg = cdnUrl + "/assets/img/the-evolution-of-olympus-grid.webp";
const jokerImg = cdnUrl + "/assets/img/olympus-grid-the-future.webp";
const webSphereImg = cdnUrl + "/assets/img/olympus-grid-a-monumental.webp";

import "../styles/blogs.scss";

const Blog = (props) => {
    return (
        <MDBox className="blogs-page" bgColor="white">
            <Banner
                image={bgImage}
                content={
                    (
                        <Container className="text-container">
                            <h1>Learn about Olympus-Grid</h1>
                        </Container>
                    )
                }
            />
            <MDBox className="blogs-container">
                <Container>
                    <Grid container spacing={5} flexGrow={1} alignContent="stretch">
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={ultimateBackendImg}
                                title="Introducing Olympus-Grid: Redefining Enterprise Architecture"
                                description='Olympus-Grid is more than a product; it’s a reimagining of how enterprise applications are built, deployed, and scaled. At its core, Olympus-Grid delivers a full-stack enterprise architecture platform designed to...'
                                footer={false}
                                link="/blog/introducing-olympus-grid"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={goldbergMachineImg}
                                title="The Evolution of Olympus-Grid: Perfection in Enterprise Architecture"
                                description='Over the years, my platform has undergone countless iterations, packaging architectures, prototypes, and namespaces. Each phase of its evolution brought new lessons and refined its purpose. Early versions of this platform...'
                                footer={false}
                                link="/blog/the-evolution-of-olympus-grid-perfection-in-enterprise-architecture"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={jokerImg}
                                title="Olympus-Grid: A Decade of Innovation, Ready for General Availability"
                                description='After more than a decade of relentless dedication and three years of meticulous development, Olympus-Grid is poised for its imminent release to general availability. This is more than a platform — it’s a transformative...'
                                footer={false}
                                link="/blog/olympus-grid-the-future-of-enterprise-architecture-is-here"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <BookingCard
                                image={webSphereImg}
                                title="Olympus-Grid: A Monumental Step Forward in Cloud Enterprise Architecture"
                                description="In the crowded world of enterprise platforms, each solution solves a specific set of challenges — whether it’s handling integrations, managing plugins, or enabling modular development. From Salesforce and ServiceNow..."
                                footer={false}
                                link="/blog/olympus-grid-a-monumental-step-forward-in-cloud-enterprise-architecture"
                            />
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
        </MDBox>
    )
}

export default Blog;